import {
  GET_HEALTH_CHECK_SYNC_DATA_STARTED,
  GET_HEALTH_CHECK_SYNC_DATA_SUCCESS
} from '../../actions/actionTypes'

const defaultState = {
  hotelData: [],
  hotelGroups: {},
  hotelChains: {},
  isLoading: true
}

export default function sync(
  state = {
    ...defaultState
  },
  action
) {
  switch (action.type) {
    case GET_HEALTH_CHECK_SYNC_DATA_STARTED:
      return {
        ...state,
        isLoading: true
      }

    case GET_HEALTH_CHECK_SYNC_DATA_SUCCESS:
      return {
        ...state,
        isLoading: false,
        hotelData: action.payload.hotelData,
        hotelGroups: action.payload.hotelGroups,
        hotelChains: action.payload.hotelChains
      }

    case 'SAVE_POSTED_SUBSIDIARY':
      return {
        ...defaultState
      }

    default:
      return state
  }
}
